import LocalizedStrings from 'localized-strings';

/**
 * @todo Validate locales
 * @see https://linear.app/shine/issue/CAC-1053
 */
const locales = new LocalizedStrings({
  en: {
    accessBankStatements: 'Accéder aux relevés bancaires',
    description:
      'Exportez vos transactions et vos factures pour une période définie.',
    generateExport: 'Générer un export comptable',
    newExport: 'Nouvel export',
    title: 'Export comptable',
  },
  fr: {
    accessBankStatements: 'Accéder aux relevés bancaires',
    description:
      'Exportez vos transactions et vos factures pour une période définie.',
    generateExport: 'Générer un export comptable',
    newExport: 'Nouvel export',
    title: 'Export comptable',
  },
} as const);

export default locales;
